import React from 'react';
import clsx from 'clsx';
import { SegmentedControl, SegmentedControlOption } from '@oysterjs/ui/segmented-control';

type Pane = 'edit' | 'preview';

/**
 * Side by side on wide screens; on narrower ones, Edit and Preview tabs. The hidden pane
 * stays mounted so switching tabs keeps the form as it was.
 */
export const EditAndPreviewPanes = ({
  edit,
  preview
}: {
  edit: React.ReactNode;
  preview: React.ReactNode;
}) => {
  const [shownPane, setShownPane] = React.useState<Pane>('edit');

  return (
    <>
      <SegmentedControl
        aria-label="Edit or preview"
        value={shownPane}
        onChange={setShownPane}
        className="mb-4 max-w-xs xl:hidden"
      >
        <SegmentedControlOption value="edit">Edit</SegmentedControlOption>
        <SegmentedControlOption value="preview">Preview</SegmentedControlOption>
      </SegmentedControl>
      {/* min-w-0 so a pane's widest content, such as a toolbar, can't widen its column past
          the screen. */}
      <div className="grid gap-8 xl:grid-cols-2 xl:items-start">
        <div className={clsx('min-w-0', shownPane !== 'edit' && 'hidden xl:block')}>{edit}</div>
        <div
          className={clsx(
            'min-w-0 xl:sticky xl:top-6',
            shownPane !== 'preview' && 'hidden xl:block'
          )}
        >
          {preview}
        </div>
      </div>
    </>
  );
};
